import {
  type CustomLocationId,
  HOUR,
  type LocationMatchInput,
  type LocationMatchSuccess,
  type SmallAddress,
  type SmallLocationData,
  toAccountAddress,
} from '@terros/common'
import { useTantalimQuery } from '../query'
import { customLocationMatchKey } from '../keys'
import { type GetHookResponse } from '../hooks'

type CustomLocationMatchInput = {
  locationId: CustomLocationId
  address: SmallAddress
}

/**
 * Finds the Terros or First American location a custom location duplicates, skipping custom locations.
 * Resolves to null when nothing matches, since query data cannot be undefined.
 */
export function useCustomLocationMatch({
  locationId,
  address,
}: CustomLocationMatchInput): GetHookResponse<SmallLocationData | null> {
  return useTantalimQuery<LocationMatchInput, LocationMatchSuccess, SmallLocationData | null>({
    url: '/location/match',
    queryKey: customLocationMatchKey(locationId),
    input: { addressParts: toAccountAddress(address), enableCustomLocationMatching: false },
    convertResponse: (data) => data.location ?? null,
    options: { staleTime: HOUR },
  })
}
